<template>
  <text-box :label="$t('components.simulationDetails.SalesBySegment.totalSalesBySegment', { kpi: customKpiName })" icon="segment" :hide-title="hideTitle">
    <template v-slot:info v-if="precision">
      <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
    </template>
    <template v-slot:info-dialog>
      <slot name="info-dialog"></slot>
    </template>
    <v-container fluid>
      <v-row>
        <v-col cols="4" v-for="(segment, key) in data.segments" :key="key">
          <sales-by-segment-chart :data="segment" :code="key" :colors="currentClientObject.colors" :custom-kpi-name="customKpiName" />
        </v-col>
      </v-row>
    </v-container>
  </text-box>
</template>

<script>
import { mapGetters } from 'vuex'
import TextBox from '@/components/TextBox.vue'
import PercentChip from '@/components/PercentChip.vue'
import SalesBySegmentChart from '@/components/simulationDetails/SalesBySegmentChart.vue'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('clients', [
      'currentClientObject'
    ])
  },
  methods: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: false
    },
    precision: {
      type: Number,
      required: false
    },
    hideTitle: {
      type: Boolean,
      required: false
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    },
    customKpiName: {
      type: String,
      required: true
    }
  },
  components: {
    TextBox,
    PercentChip,
    SalesBySegmentChart
  }
}
</script>
